import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Particles from "vue3-particles";

import './assets/css/global.css'
import "vue-loading-overlay/dist/css/index.css";

createApp(App).use(router).use(Particles).mount('#app')
